import * as R from 'ramda'

export {ltrim, rtrim, trim} from './trim'
export {upperFirst, lowerFirst} from './case'
export {slugify} from './slugify'

export const fancyApostrophe = '’'

export const onlyNumbers = (s: string): string => s.replace(/\D/g, '')
export const areStrings = R.all((s: any) => typeof s === 'string')
